<script>
  import ArrowDown from "./ArrowDown.svelte";
  import Button from "./Button.svelte";

  export let backgroundImage;
  export let zoomImage;
  export let dark = false;

  function handleClick(event) {
    if (dark) {
      window.open(
        "https://www.decathlon.fr/p/chaussures-de-tennis-homme-ts960-bleues-multi-court/_/R-p-300486?mc=8573383",
        "_blank"
      );
    } else {
      window.open(
        "https://www.decathlon.fr/p/chaussures-de-tennis-homme-ts990-jaunes-multi-court/_/R-p-300116?mc=8573378",
        "_blank"
      );
    }
  }
</script>

<div class="lateral-images">
  <div class="lateral-images__image-container">
    <div class="lateral-images__image">
      <img src={backgroundImage} />
    </div>
    <div
      class="lateral-images__image--zoomed"
      class:lateral-images__image--zoomed--dark={dark}
      style="background-image: url('{zoomImage}')"
    />
  </div>
  <div
    class="lateral-images__separators-container"
    class:lateral-images__separators-container--dark={dark}
  >
    <div
      class="lateral-images__separators"
      class:lateral-images__separators--dark={dark}
    >
      <div
        class="lateral-images__separator"
        class:lateral-images__separator--dark={dark}
      >
        <div
          class="lateral-images__separator-nested"
          class:lateral-images__separator-nested--dark={dark}
        />
      </div>
    </div>
  </div>
  <div class="lateral-images__actions">
    <Button label={"Voir le produit"} {dark} on:click={handleClick} />
    <ArrowDown {dark} />
  </div>
</div>

<style lang="scss">
  @import "./assets/styles/variables";

  .lateral-images {
    padding-bottom: 2rem;
    position: relative;
    overflow: hidden;

    &__image-container {
      position: relative;
    }

    &__image img {
      width: 100%;
    }

    &__image--zoomed {
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 100%;
      border-radius: 100%;
      border: 2px solid white;
      box-shadow: 0 0 1rem $shadow-color-light;
      height: 25%;
      content: "";
      left: 21%;
      min-height: 64px;
      min-width: 64px;
      position: absolute;
      top: 43%;
      width: 25%;

      &--dark {
        background-position: 40% 68%;
        border: 2px solid $color-orange-light;
        box-shadow: 0 0 1rem $shadow-color-dark;
        left: 27%;
        top: 51%;
      }
    }

    &__separators-container {
      height: 1rem;
      position: absolute;
      top: 65%;
      width: 100%;

      &--dark {
        transform: scale(-1) translateY(1px);
        transform-origin: center;
      }
    }

    &__separators {
      filter: brightness(250%) drop-shadow(0 0 3rem rgba(0, 0, 0, 0.2));
      height: 256px;
      left: 0;
      overflow: hidden;
      position: absolute;
      right: 0;
      transform-origin: right center;
      transform: translateX(-50%) rotate(7.3deg);
      width: 200%;

      &--dark {
        filter: drop-shadow(0 0 3rem #f4c29a);
      }
    }

    &__separator,
    &__separator-nested {
      background-color: white;
      height: 1rem;
      position: absolute;
      z-index: 2;

      &--dark {
        background-color: #f7dbc5;
      }
    }

    &__separator {
      left: 0;
      right: 0;
      top: 0;
      transform: translateX(-50%);
      width: 200%;

      &--dark {
      }

      &-nested {
        left: 0;
        right: 0;
        top: 0;
        transform: translate(0, -25%) rotate(120deg);
        transform-origin: 40%;
        width: 200%;

        &--dark {
        }
      }
    }

    &__actions {
      align-items: center;
      display: flex;
      flex-direction: column;
      transform: translateY(2rem);
    }
  }
</style>
